import { useEffect } from 'react';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import aa from 'search-insights';
import { v4 as uuidv4 } from 'uuid';
import { ANONYMOUS_USER_TOKEN, LAST_ALGOLIA_QUERY_ID } from 'helpers/constants/localStorage';
import { useAccount } from 'frontastic';
import { Configure, useInstantSearch } from 'react-instantsearch-core';
import { useSearchParams } from 'next/navigation';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

interface Props {
  categorySlug?: string;
  query?: string;
}

const InsightsMiddleware: React.FC<Props> = ({ categorySlug = '', query = '' }: Props) => {
  const {
    addMiddlewares,
    results: { queryID },
  } = useInstantSearch();

  const { account } = useAccount();
  const [isDesktopSize] = useMediaQuery(desktop);
  //const searchParams = useSearchParams();
  // const query = searchParams?.get('q') || '';
  useEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: aa,
      onEvent({ insightsMethod, payload }, insightsClient) {
        const isExcluded = ['Hits Viewed'].includes((payload as Record<string, string>).eventName);

        // Log the payload to ensure it's being passed correctly
        console.log('Insights Event Payload:', payload);

        if (!insightsMethod || isExcluded) return;

        // Log insights method to check for correct execution
        console.log('Insights Method:', insightsMethod);

        insightsClient(insightsMethod, payload as Record<string, string>);
      },
    });

    return addMiddlewares(middleware);
  }, [addMiddlewares]);

  useEffect(() => {
    // Set user token logic
    // if (account?.accountId) aa('setUserToken', account.accountId);
    // else {
    //     const token = window.localStorage.getItem(ANONYMOUS_USER_TOKEN);
    //     if (token) aa('setUserToken', token);
    //     else {
    //         const randomToken = uuidv4();
    //         window.localStorage.setItem(ANONYMOUS_USER_TOKEN, randomToken);
    //         aa('setUserToken', randomToken);
    //     }
    // }
  }, [account?.accountId]);

  useEffect(() => {
    // Store the query ID for tracking
    if (queryID) window.localStorage.setItem(LAST_ALGOLIA_QUERY_ID, queryID);
  }, [queryID]);

  const filters = categorySlug ? `categoryKeys.en-GB:\"${categorySlug}\"` : '';
  const queryContext = isDesktopSize ? 'desktop' : 'mobile';

  return (
    <>
      <Configure
        clickAnalytics={true}
        maxValuesPerFacet={100}
        query={query ?? ''}
        filters={filters}
        facets={['*']}
        ruleContexts={[queryContext]}
      />
    </>
  );
};

export default InsightsMiddleware;
